import { useCallback, useRef, useState } from 'react';
import SignatureCanvas from 'react-signature-canvas';

export const useSignaturePad = () => {
	const sigCanvasRef = useRef<SignatureCanvas | null>(null);
	const [isEmpty, setIsEmpty] = useState(true);

	const getSignatureImageUrl = () => {
		if (sigCanvasRef.current) {
			return sigCanvasRef.current.getTrimmedCanvas().toDataURL('image/png');
		}
	};

	const clearSignature = useCallback(() => {
		sigCanvasRef.current?.clear();
		setIsEmpty(true);
	}, []);

	const handleStrokeEnd = useCallback(() => {
		setIsEmpty(!!sigCanvasRef.current?.isEmpty());
	}, []);

	return {
		clearSignature,
		getSignatureImageUrl,
		sigCanvasRef,
		isEmpty,
		handleStrokeEnd,
	};
};
